import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ce082c4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mainTop",
  class: "main_top"
}
const _hoisted_2 = { class: "main_title" }
const _hoisted_3 = { class: "main_content" }
const _hoisted_4 = { class: "company_info" }
const _hoisted_5 = { class: "info_left" }
const _hoisted_6 = { class: "info_box" }
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "first" }
const _hoisted_9 = { class: "small-text gray" }
const _hoisted_10 = { class: "info_right" }
const _hoisted_11 = { class: "info_logo" }
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_14 = { class: "deal_title" }
const _hoisted_15 = {
  id: "mainTap",
  class: "main_tap"
}
const _hoisted_16 = {
  key: 'info',
  class: "content"
}
const _hoisted_17 = { class: "content_box" }
const _hoisted_18 = { class: "col_right" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "regular bold" }, "MY 조합원 자격 정보")
], -1))
const _hoisted_20 = { class: "space-between" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_22 = { class: "gray" }
const _hoisted_23 = { class: "space-between" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "출자 금액", -1))
const _hoisted_25 = { class: "strong" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_27 = { class: "space-between" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주당 평균 구매가격", -1))
const _hoisted_29 = { class: "strong" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_31 = { class: "space-between" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "현재 보유 자격", -1))
const _hoisted_33 = { class: "strong" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("주")
const _hoisted_35 = { class: "content_box" }
const _hoisted_36 = { class: "col_right" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "space-between" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "regular bold" }, "조합 정보")
], -1))
const _hoisted_38 = { class: "space-between" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_40 = { class: "gray" }
const _hoisted_41 = { class: "space-between" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "출자 금액", -1))
const _hoisted_43 = { class: "strong" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_45 = { class: "space-between" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "주당 매수가", -1))
const _hoisted_47 = { class: "strong" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode(" 원")
const _hoisted_49 = { class: "space-between" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "보유 주식수", -1))
const _hoisted_51 = { class: "strong" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode(" 주")
const _hoisted_53 = { class: "space-between" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "조합원", -1))
const _hoisted_55 = { class: "space-between" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "리드엔젤", -1))
const _hoisted_57 = {
  key: 'history',
  class: "content"
}
const _hoisted_58 = { class: "main_process" }
const _hoisted_59 = { class: "row" }
const _hoisted_60 = { class: "polygon_b" }
const _hoisted_61 = { class: "process_status" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot_b_line" }, null, -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dot_g_line" }, null, -1))
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { class: "row" }
const _hoisted_67 = {
  class: "polygon_b",
  style: {"background-image":"url('/assets/icon/polygon_g.png')"}
}
const _hoisted_68 = { class: "process_status" }
const _hoisted_69 = { class: "main_file" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "regular bold" }, " 조합 서류 ", -1))
const _hoisted_71 = ["onClick"]
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "main_file" }
const _hoisted_74 = { class: "regular bold" }
const _hoisted_75 = ["onClick"]
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { class: "main_board" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_board_title" }, " 조합 게시판 ", -1))
const _hoisted_79 = {
  key: 0,
  class: "write_box"
}
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" 새로운 소식이나 의견이 있으세요? ")
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" 작성하기 ")
const _hoisted_82 = {
  key: 1,
  class: "write_box light"
}
const _hoisted_83 = /*#__PURE__*/_createTextVNode(" 의견을 작성하시려면 ")
const _hoisted_84 = /*#__PURE__*/_createTextVNode(" 로그인> ")
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gray-margin" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_img = _resolveComponent("ag-img")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_partnership_board_list = _resolveComponent("partnership-board-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("img", {
                class: "arrow_b",
                src: "/assets/icon/btn_back.png",
                srcset: "/assets/icon/btn_back@2x.png 2x,/assets/icon/btn_back@3x.png 3x",
                onClick: _cache[0] || (_cache[0] = () => { _ctx.router.go(-1) })
              })
            ]),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: "title bold",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.useCompanyModal(_ctx.stockItemInfo.stockItemId)))
                    }, _toDisplayString(_ctx.stockItemInfo.stockItemName) + " > ", 1),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, "추정 시총 " + _toDisplayString(_ctx.numberToKorean(_ctx.stockItemInfo.currentValuation)) + "원", 1)
                      ])
                    ]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_ag_box_s, {
                        css: {
                      display:'flex',
                      color:'green1',
                      typography:'text14r'
                    },
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.useCompanyModal(_ctx.stockItemInfo.stockItemId, 'community')))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ag_box_s, { css: {
                        mr:'10px',
                        display:'flex',
                        alignItems: 'center',
                        lineHeight: '14px'
                      } }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ag_img, {
                                src: "/assets/icon/small_leaf_g.png",
                                width: "15px",
                                css: {
                          mr: '5px'
                        }
                              }),
                              _createTextVNode(" " + _toDisplayString(_ctx.stockItemInfo.avgPoint ? Number(_ctx.stockItemInfo.avgPoint).toFixed(1) : ''), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ag_box_s, { css: {
                        display:'flex',
                        alignItems: 'center'
                      } }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                class: "chatbubble",
                                icon: _ctx.chatbubble,
                                css: {color:'green'}
                              }, null, 8, ["icon"]),
                              _createTextVNode(" " + _toDisplayString(_ctx.$filters.currency(_ctx.stockItemInfo.count)) + " > ", 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("img", {
                      class: "img-circle img-responsive",
                      src: _ctx.stockItemInfo ? _ctx.stockItemInfo.companyLogo : '',
                      alt: "logo"
                    }, null, 8, _hoisted_12),
                    _hoisted_13
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.partnership.partnershipName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.activeTab === 'info' ? 'tab_selected' : 'tab_unselected']),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTab('info')))
            }, " 조합 정보 ", 2)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createElementVNode("div", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myPartnershipAsset.myStatus, (status, idx) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: (status, idx),
                        class: _normalizeClass(status === '참여' ? 'blue' : 'green')
                      }, [
                        _createTextVNode(_toDisplayString(status) + " ", 1),
                        _withDirectives(_createElementVNode("span", _hoisted_22, " · ", 512), [
                          [_vShow, _ctx.myPartnershipAsset.myStatus.length !== idx+1]
                        ])
                      ], 2))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$filters.currency(Math.floor(_ctx.myPartnershipAsset.asset))), 1),
                    _hoisted_26
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$filters.currency(Math.floor(_ctx.myPartnershipAsset.avgPrice))), 1),
                    _hoisted_30
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_33, _toDisplayString((+_ctx.myPartnershipAsset.sumQty).toFixed(2)), 1),
                    _hoisted_34
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _hoisted_37,
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.printDate(_ctx.partnershipAsset.foundAt)) + " 설립 ", 1)
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipAsset.expectTotalAmountTo)), 1),
                    _hoisted_44
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipAsset.purchasePrice)), 1),
                    _hoisted_48
                  ])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("div", null, [
                    _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$filters.currency(_ctx.partnershipAsset.totalQty)), 1),
                    _hoisted_52
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("div", null, _toDisplayString(_ctx.partnershipAsset.investorLength) + "명", 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("div", null, _toDisplayString(_ctx.partnershipAsset.leadName), 1)
                ])
              ])
            ])
          ], 512)), [
            [_vShow, _ctx.selectedPartnership && (_ctx.activeTab === 'info' || _ctx.activeTab === 'history')]
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_57, null, 512)), [
            [_vShow, _ctx.activeTab === 'history']
          ]),
          _createElementVNode("div", _hoisted_58, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getCurStatusArr(), (process, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: (process, idx)
              }, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, _toDisplayString(idx+1), 1),
                  _createElementVNode("div", _hoisted_61, _toDisplayString(_ctx.processStatus[process]), 1)
                ]),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2], (d_idx) => {
                  return _withDirectives(_createElementVNode("div", {
                    key: d_idx,
                    class: "dot_b"
                  }, _hoisted_63, 512), [
                    [_vShow, idx !== _ctx.getCurStatusArr().length-1]
                  ])
                }), 64))
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getLeftStatusArr(), (process, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                key: (process, idx)
              }, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1,2], (d_idx) => {
                  return _createElementVNode("div", {
                    key: d_idx,
                    class: "dot_b"
                  }, _hoisted_65)
                }), 64)),
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.getCurStatusArr().length+idx+1), 1),
                  _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.processStatus[process]), 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipFiles, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                key: file,
                class: "space-between"
              }, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (_ctx.openPartnershipFile(file.partnershipFileId)), ["prevent"])
                }, _toDisplayString(file.fileName), 9, _hoisted_71),
                _createElementVNode("img", {
                  class: "download_btn",
                  src: "/assets/icon/download_btn@3x.png",
                  onClick: ($event: any) => (_ctx.openPartnershipFile(file.partnershipFileId))
                }, null, 8, _hoisted_72)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_73, [
            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.stockItemInfo.stockItemName) + " 서류 ", 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partnershipCompanyFiles, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                key: file,
                class: "space-between"
              }, [
                _createElementVNode("a", {
                  onClick: _withModifiers(($event: any) => (_ctx.openPartnershipFile(file.partnershipFileId)), ["prevent"])
                }, _toDisplayString(file.fileName), 9, _hoisted_75),
                _createElementVNode("img", {
                  class: "download_btn",
                  src: "/assets/icon/download_btn@3x.png",
                  onClick: ($event: any) => (_ctx.openPartnershipFile(file.partnershipFileId))
                }, null, 8, _hoisted_76)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_77, [
            _hoisted_78,
            (_ctx.hasSession())
              ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                  _hoisted_80,
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent write_btn",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openModal({})))
                  }, [
                    _hoisted_81,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("div", {
                    class: "ion-activatable ripple-parent",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$global.openLoginModal()))
                  }, [
                    _hoisted_84,
                    _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
                  ])
                ]))
          ]),
          _createVNode(_component_partnership_board_list, { "partnership-id": _ctx.paramsId }, null, 8, ["partnership-id"]),
          _hoisted_85
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}